<template>
    <div>
        <div class="flex-level p-3 bt-1">
            <div class="wp-4">
                <p class="grey mb-1 mt-0">{{ $l10n.__('Compte') }}</p>
                <p class="my-0">{{ email }}</p>
            </div>
            <div class="wp-3">
                <p class="grey mb-1 mt-0">{{ $l10n.__('Statut') }}</p>
                <div class="chip" :class="`chip-${syncStatus.type}`"></div>
                {{ syncStatus.message }}
            </div>
            <div class="wp-2">
                <el-dropdown placement="bottom-end">
                    <span class="link">{{ $l10n.__('Options') }}</span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item
                                ><a
                                    class="btn-loading"
                                    href="?_f=prefsNylas&amp;action=cleanCache"
                                    >{{ $l10n.__('Mettre à jour le cache') }}</a
                                ></el-dropdown-item
                            >
                            <el-dropdown-item
                                ><a
                                    class="btn-loading"
                                    href="?_f=prefsNylas&amp;action=checkStatus"
                                    >{{ $l10n.__('Actualiser le statut') }}</a
                                ></el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
            <div class="flex-item-right">
                <a
                    v-if="isAdmin || !isEmailsSentFromCorp"
                    class="btn btn-danger fright"
                    @click="logout()"
                >
                    {{ $l10n.__('Déconnexion') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    name: 'EmailSettingsAccountModeSync',
    props: {
        status: {
            type: String,
            required: false,
            default: '',
        },
        email: {
            type: String,
            required: false,
            default: '',
        },
        isEmailsSentFromCorp: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapStateUser({
            isAdmin: 'isAdmin',
        }),
        /**
         * Return the message status of the synchronized account
         */
        syncStatus() {
            switch (this.status) {
                case 'running':
                case 'downloading':
                    return { type: 'success', message: this.$l10n.__('Connecté') };
                case 'invalid-credentials':
                    return { type: 'warning', message: this.$l10n.__('Mot de passe incorrect') };
                default:
                    return { type: 'error', message: this.$l10n.__('Erreur de synchronisation') };
            }
        },
    },
    methods: {
        /**
         * Call legacy method to desynchronize the account
         */
        logout() {
            window.PrefsEmail.logout();
        },
    },
};
</script>
